import React from "react";
import { Props } from "./IButton";
import styles from "./button.module.scss";

const Button: React.FC<Props> = ({
  width,
  color,
  background,
  margin,
  transition,
  padding,
  borderRadius,
  onClick,
  children,
}) => {
  const style = {
    width: width || "100%",
    background: background || "rgba(0, 0, 0, 0)",
    margin: margin || "0",
    transition: transition || "0.2s ease-in-out",
    padding: padding || "11px 0",
    borderRadius: borderRadius || "4px",
    cursor: "pointer",
  };

  return (
    <button
      style={style}
      onClick={onClick}
      className={`${styles.Btn} ${
        color === "green"
          ? styles.Btn_Green
          : color === "black"
          ? styles.Btn_Black
          : styles.Btn_Red
      }`}
    >
      {children}
    </button>
  );
};

export default Button;
